import * as API from 'core/api';
import * as SalesStore from '../SalesStore';
import { RestaurantFacade } from 'pos/facades';
import { CustomerDisplay } from 'pos/services';
import { Message } from 'core/ui-next/modal';

export default async function setPriceList({ priceListId }: { priceListId: number }): Promise<void> {

	const ticket = SalesStore.getTicket();
	const priceLists = await RestaurantFacade.getAllPriceListsByTicketId(ticket.Id);

	const priceListToSet = priceLists.find(x => x.Id === priceListId);
	if (!priceListToSet) {
		await Message.show(API.Res.Msg.MSG_INVALID_PRICELIST());
		return;
	}

	await SalesStore.setTicketPriceList(priceListToSet.Id);
	await CustomerDisplay.displayPriceList(SalesStore.getTicket());
}